// Custom events have been added to the theme to make adding
// custom functionality easier. The below events have been
// exposed as well as the associated data for each event.
// To enable this functionality update the 'useCustomEvents' variable in
// the theme.liquid file to 'true'.

// This event fires whenever an item has been added to the cart.
// This event is exposed when the ajax cart is enabled.
// The product object is passed within the detail object.
document.addEventListener("cart:item-added", function (evt) {
  console.log("Item added to the cart");
  console.log(evt.detail.product);
});

// This event fires whenever the cart is updated.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.
document.addEventListener("cart:updated", function (evt) {
  console.log("Cart updated");
  console.log(evt.detail.cart);
});

// This event fires whenever there is an error when adding an item to the cart.
// This error is typically due to a product not having sufficient stock.
// The error message is passed within the detail object.
document.addEventListener("cart:error", function (evt) {
  console.log("Cart error");
  console.log(evt.detail.errorMessage);
});

// This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.
document.addEventListener("quick-cart:open", function (evt) {
  console.log("Quick cart opened");
  console.log(evt.detail.cart);
});

// This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.
document.addEventListener("quick-cart:close", function () {
  console.log("Quick cart closed");
});

// This event fires whenever a variant product is selected.
// This event is exposed when a 'Variant selectors' block has been added to
// a product template or featured product section
// The selected variant object is passed within the detail object.
document.addEventListener("product:variant-change", function (evt) {
  console.log("Product variant changed");
  console.log(evt.detail.variant);
});

// This event fires whenever a product quanatiy is updated.
// This event is exposed when a 'Quantity selector' block has been added to
// a product template or featured product section
// The quantity and selected variant object is passed within the detail object.
document.addEventListener("product:quantity-update", function (evt) {
  console.log("Product quantity updated");
  console.log(evt.detail.quantity, evt.detail.variant);
});

// This event fires whenever quickview modal is opened.
// This event is exposed when the 'Enable quick view' feature is enabled
// And a quick view modal is opened.
document.addEventListener("quickview:loaded", function () {
  console.log("Quickview loaded");
});

// ---
// Curious Creatures
// Custom navigation arrows for product page
// ---
const CuriousCreatures = {};

// CC Product Media Navigation arrows for Thumbnails mode
CuriousCreatures.ProductMediaNavigation  = class {
  constructor() {
    // Only proceed if we're on a page with product media galloery
    if (document.querySelector('.product__media')) {

      // Selectors and classes
      this.productPrimaryContainerClass = '.product__primary-left'

      this.productMediaNavButtonSelector = '.cc___product__media-nav-button';
      this.productMediaNavButtonPrevClass = 'cc___product__media-nav-button--prev';
      this.productMediaNavButtonNextClass = 'cc___product__media-nav-button--next';

      this.productMediaThumbnailsSelector = '.product-thumbnails__items';
      this.productMediaThumbnailParentSelector = '.product-thumbnails__item';
      this.productMediaThumbnailSelector = '.product-thumbnails__item-link';
      this.productMediaActiveThumbnailSelector = `${this.productMediaThumbnailSelector}.active`;

      // Initialize event listeners
      this.initEventListeners();
    }
  }

  // Method to initialize event listeners
  initEventListeners() {
    document.querySelector(this.productPrimaryContainerClass).addEventListener('click', (event) => {
      const productMediaNavButton = event.target.closest(this.productMediaNavButtonSelector);
      productMediaNavButton && this.handleNavButtonClick(productMediaNavButton);
    });
  }

  // Method to handle navigation button clicks
  handleNavButtonClick(button) {
    const activeThumbnail = document.querySelector(this.productMediaActiveThumbnailSelector);
    const activeThumbnailParent = activeThumbnail.closest(this.productMediaThumbnailParentSelector);
    const thumbnails = activeThumbnailParent.closest(this.productMediaThumbnailsSelector);

    let activeThumbnailParentSibling;

    if (button.classList.contains(this.productMediaNavButtonPrevClass)) {
      activeThumbnailParentSibling = activeThumbnailParent.previousElementSibling || thumbnails.lastElementChild;
    } else if (button.classList.contains(this.productMediaNavButtonNextClass)) {
      activeThumbnailParentSibling = activeThumbnailParent.nextElementSibling || thumbnails.firstElementChild;
    }
    
    activeThumbnailParentSibling?.querySelector(this.productMediaThumbnailSelector).click();
  }
};

// Initialize the CC ProductMediaNavigation class
const ccProductMediaNavigation = new CuriousCreatures.ProductMediaNavigation();

// Gallery carousel mobile pagination dots
CuriousCreatures.GalleryCarousel = class {
  constructor() {
    this.mobileQuery = window.matchMedia('(max-width: 719px)');
    this.initAll();

    document.addEventListener('shopify:section:load', (event) => {
      const section =
        event.target.querySelector('[data-section-type="gallery-carousel"]') ||
        (event.target.matches?.('[data-section-type="gallery-carousel"]') ? event.target : null);

      if (section) {
        this.initSection(section);
      }
    });
  }

  initAll() {
    document.querySelectorAll('[data-section-type="gallery-carousel"]').forEach((section) => {
      this.initSection(section);
    });
  }

  initSection(section) {
    const swiperEl = section.querySelector('.gallery-carousel__content');
    const pagination = section.querySelector('[data-gallery-carousel-pagination]');
    const dots = pagination?.querySelectorAll('[data-gallery-carousel-dot]');

    if (!swiperEl || !pagination || !dots.length) return;

    if (section.dataset.ccGalleryCarouselInit === 'true') return;

    this.waitForSwiper(swiperEl, (swiper) => {
      section.dataset.ccGalleryCarouselInit = 'true';
      this.bindPagination(section, swiper, pagination, dots);
    });
  }

  waitForSwiper(swiperEl, callback, attempts = 0) {
    if (swiperEl.swiper) {
      callback(swiperEl.swiper);
      return;
    }

    if (attempts >= 50) return;

    window.setTimeout(() => {
      this.waitForSwiper(swiperEl, callback, attempts + 1);
    }, 100);
  }

  bindPagination(section, swiper, pagination, dots) {
    const getActiveIndex = () => {
      return typeof swiper.realIndex === 'number' ? swiper.realIndex : swiper.activeIndex;
    };

    const updateActiveDot = () => {
      const activeIndex = getActiveIndex();

      dots.forEach((dot, index) => {
        const isActive = index === activeIndex;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-current', isActive ? 'true' : 'false');
      });
    };

    const togglePaginationVisibility = () => {
      pagination.hidden = !this.mobileQuery.matches || dots.length <= 1;
    };

    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        const index = parseInt(dot.dataset.galleryCarouselDot, 10);

        if (Number.isNaN(index)) return;

        if (swiper.params.loop) {
          swiper.slideToLoop(index);
        } else {
          swiper.slideTo(index);
        }
      });
    });

    swiper.on('slideChange', updateActiveDot);
    swiper.on('breakpoint', updateActiveDot);

    updateActiveDot();
    togglePaginationVisibility();

    if (typeof this.mobileQuery.addEventListener === 'function') {
      this.mobileQuery.addEventListener('change', togglePaginationVisibility);
    } else {
      this.mobileQuery.addListener(togglePaginationVisibility);
    }
  }
};

const initGalleryCarousels = () => {
  new CuriousCreatures.GalleryCarousel();
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initGalleryCarousels);
} else {
  initGalleryCarousels();
}

// ---
// Associated variant products (custom.associated_variant_product metafield)
// ---
CuriousCreatures.AssociatedVariants = class {
  constructor() {
    this.productRoot = document.querySelector('[data-section-type="product"]');
    this.dataScript = document.querySelector('[data-associated-variants-data]');

    if (!this.productRoot || !this.dataScript) return;

    try {
      this.data = JSON.parse(this.dataScript.textContent);
    } catch (error) {
      return;
    }

    document.addEventListener('product:variant-change', (event) => {
      this.handleVariantChange(event.detail?.variant);
    });

    this.bindVariantOptionListeners();
    this.syncFromCurrentSelection();
  }

  bindVariantOptionListeners() {
    this.productRoot.addEventListener('change', (event) => {
      const target = event.target;

      if (
        !target.matches('[name^="options"]') &&
        !target.matches('[data-variant-select]') &&
        !target.matches('select[name="id"]')
      ) {
        return;
      }

      this.scheduleSync();
    });

    this.productRoot.addEventListener('click', (event) => {
      const button = event.target.closest('[data-option-buttons] [data-button]');

      if (!button || !this.productRoot.contains(button)) return;

      this.scheduleSync();
    });
  }

  scheduleSync() {
    window.requestAnimationFrame(() => {
      window.requestAnimationFrame(() => {
        this.syncFromCurrentSelection();
      });
    });
  }

  syncFromCurrentSelection() {
    const variantId = this.getSelectedVariantId();

    if (!variantId) return;

    this.handleVariantChange({ id: variantId });
  }

  getSelectedVariantId() {
    const selectedOption = this.productRoot.querySelector(
      '[data-variant-select] option:checked, select[name="id"] option:checked'
    );

    if (!selectedOption?.value) return null;

    return parseInt(selectedOption.value, 10);
  }

  getPicker() {
    return document.querySelector('[data-associated-variants-picker]');
  }

  getVariantData(variant) {
    if (!variant?.id || !this.data?.variants) return null;
    return this.data.variants[String(variant.id)] || null;
  }

  handleVariantChange(variant) {
    const variantId = variant?.id ? parseInt(variant.id, 10) : null;

    if (!variantId) {
      this.lastHandledVariantId = null;
      this.updatePicker(null);
      return;
    }

    if (this.lastHandledVariantId === variantId) return;

    this.lastHandledVariantId = variantId;

    const variantData = this.getVariantData({ id: variantId });

    if (!variantData) return;

    this.updatePicker(variantData);
  }

  updatePicker(variantData) {
    const picker = this.getPicker();
    if (!picker) return;

    const shouldShow =
      variantData?.hasAssociatedVariants && variantData.associatedVariants?.length > 0;

    picker.classList.toggle('hidden', !shouldShow);
    picker.toggleAttribute('hidden', !shouldShow);

    if (!shouldShow) {
      const inner = picker.querySelector('.product__color-swatches--inner');
      if (inner) inner.innerHTML = '';
      return;
    }

    const swatches = variantData.associatedVariants
      .map((item) => {
        const imageHtml = item.image
          ? `<img src="${item.image}" alt="${this.escapeHtml(item.title)}" loading="lazy" role="presentation">`
          : '';

        if (item.selected) {
          return `
            <span
              data-shape="square"
              data-size="medium"
              class="product__color-swatch product__color-swatch--associated-variant selected"
              aria-label="${this.escapeHtml(item.title)}"
              aria-current="true"
            >
              ${imageHtml}
            </span>
          `;
        }

        return `
          <a
            href="${item.url}"
            data-shape="square"
            data-size="medium"
            class="product__color-swatch product__color-swatch--associated-variant"
            aria-label="${this.escapeHtml(item.title)}"
          >
            ${imageHtml}
          </a>
        `;
      })
      .join('');

    const inner = picker.querySelector('.product__color-swatches--inner');
    if (inner) inner.innerHTML = swatches;
  }

  escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new CuriousCreatures.AssociatedVariants();
  });
} else {
  new CuriousCreatures.AssociatedVariants();
}